<template>
  <div>
    <q-dialog v-if="flModal" v-model="flModal">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-large">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title
              ><translate>RESULT_FILTERS</translate>
            </q-toolbar-title>
            <q-btn v-close-popup flat round dense size="1.5em" icon="cancel" />
          </q-toolbar>
        </q-header>
        <q-page-container style="max-height: calc(75vh - 20px)">
          <truck-weight-capacity-table
            v-if(datatable.columns?.length)
            ref="jtDataTable"
            :fields="datatable.columns"
            :extra-params="filterParams"
            :nm-interface="nmInterface"
            :singleselect="!singleselect"
            :multiselect="multiselect"
            @selection="selection"
            class="table-search"
          />
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtDataTable } from 'jtech-webcomps'
import TruckWeightCapacityTable from './TruckWeightCapacityTable'

@Component({
  mixins: [TruckWeightCapacityTable],
  props: {
    filterParams: Object,
    multiselect: {
      type: Boolean,
      default: false
    },
    nmInterface: {
      type: String,
      required: true
    },
    flModal: {
      type: Boolean,
      default: false
    }
  }
})
class TruckWeightCapacitySearchModal extends Vue {
  selectedItem = {};
  datatable = { columns: [] };
  async beforeMount () {
    this.datatable = await repository.resolveDatatable(null, {
      nmInterface: this.nmInterface
    })
  }

  @Watch('flModal', { deep: true })
  flModalWatcher (newFlModal) {
    this.$emit('changeModal', newFlModal)
  }

  selection (data) {
    if (!this.multiselect) {
      this.$emit('selection', data[0])
    }
  }

  onSelect () {
    this.$emit('selection', this.$refs.jtDataTable.selected)
  }

  refresh () {
    this.$refs.jtDataTable.refresh()
  }

  onClose () {
    this.$emit('close')
  }

  onOpen () {
    this.$emit('open')
  }

  data () {
    return {
      fixed: false
    }
  }
}
export default TruckWeightCapacitySearchModal
</script>
<style lang="stylus" scoped>
#truck-weight-capacity-search-modal {
  .q-card {
    #pesquisa-table-container {
      position: initial;
      height: calc(100% - 64px);
      overflow: auto;
      padding: 0;
    }
  }

  .q-table-container {
    height: 100%;
    overflow: hidden;
  }

  .q-table-middle.scroll {
    height: calc(100% - 50px);
  }
}

.table-search{
  .q-tr, .q-td {
    padding: 5px!important;
   }

}

.header-dialog {
  margin: 10px;
  border-radius: 5px;
}
</style>
